import type { ComponentProps } from 'react'
import { cn } from '../lib/cn'
export function FormLayout({ className, ...props }: ComponentProps<'form'>) {
  return <form {...props} data-slot="form-layout" className={cn('space-y-5', className)} />
}
export function FormGrid({
  className,
  columns = 2,
  ...props
}: ComponentProps<'div'> & { columns?: 1 | 2 | 3 }) {
  return (
    <div
      {...props}
      data-slot="form-grid"
      className={cn(
        'grid gap-4',
        columns === 2 && 'sm:grid-cols-2',
        columns === 3 && 'sm:grid-cols-3',
        className,
      )}
    />
  )
}
export function FormSection({ className, ...props }: ComponentProps<'section'>) {
  return <section {...props} data-slot="form-section" className={cn('space-y-4', className)} />
}
